module.exports = __webpack_public_path__ + "img/6s.eb247074.png";